<template>
    <div class="oauth-login-layout">
        <div class="oauth-login-layout__languages">
            <languages variant="link" toggle-class="oauth-login-layout__language-selector" />
        </div>
        <div class="oauth-login-layout__content">
            <router-view />
        </div>
        <p class="oauth-login-layout__copy">
            {{ $t('Protected by Accounts') }} &middot; &copy; {{ new Date().getFullYear() }}
        </p>
    </div>
</template>

<script>
import Languages from '@/components/Languages';

export default {
    name: 'oauth-login-layout',
    components: { Languages },
};
</script>

<style lang="scss">
.oauth-login-layout {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 24px 16px 32px;

    &__languages {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 24px;
    }

    &__language-selector {
        font-weight: 600 !important;
    }

    &__content {
        align-items: center;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
        width: 100%;
    }

    &__copy {
        color: #6b7280;
        font-size: 14px;
        margin: 0;
        padding-top: 24px;
        text-align: center;
    }
}
</style>
